import React from 'react';
import { ArrowLeft } from 'lucide-react';

export function BackButton({ onClick }) {
  return (
    <button type="button" className="back-button" onClick={onClick}>
      <span className="back-button-content">
        <ArrowLeft className="back-button-arrow" size={28} strokeWidth={2.75} aria-hidden="true" />
        <span>Back</span>
      </span>
    </button>
  );
}

export function QueueNowPlayingCard({ track, onOpen }) {
  if (!track) return null;

  return (
    <button
      type="button"
      className="now-playing-banner-queue"
      onClick={onOpen}
      aria-label={`Open Now Playing for ${track.name}`}
    >
      <p className="label">NOW PLAYING</p>
      <h2>{track.name}</h2>
      <p>{track.artist}</p>
    </button>
  );
}
